import { render, staticRenderFns } from "./EditarEscola.vue?vue&type=template&id=2fce76ee&scoped=true&"
import script from "./EditarEscola.vue?vue&type=script&lang=js&"
export * from "./EditarEscola.vue?vue&type=script&lang=js&"
import style0 from "./EditarEscola.vue?vue&type=style&index=0&id=2fce76ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fce76ee",
  null
  
)

export default component.exports